import { useCallback } from "react";

import { createFileRoute, useNavigate } from "@tanstack/react-router";

import { Route as WalletRoute } from "@app/navigation/routes/_private/wallet";
import { Route as SignInRoute } from "@app/navigation/routes/_public/sign-in";
import { SignUpConnector } from "@pages/sign-up/sign-up-connector";

export const Route = createFileRoute("/_public/sign-up")({
  component: RouteComponent,
});

function RouteComponent() {
  const navigate = useNavigate();
  const handleSuccessSignIn = useCallback(async () => {
    await navigate({ to: WalletRoute.fullPath });
  }, [navigate]);
  const handleSignIn = useCallback(async () => {
    await navigate({ to: SignInRoute.fullPath });
  }, [navigate]);

  return (
    <SignUpConnector
      onSignIn={handleSignIn}
      onSuccessSignUp={handleSuccessSignIn}
    />
  );
}
